import config from '@/config';
import fetch from '@/fetch';

const BASE_URL = config.url.api.transfeera + '/app/transferValueSetting';
export default {
  getAll: () => fetch(`${BASE_URL}`)
};
